import React from 'react';
import { Link } from 'react-router-dom';

import {
  number,
  remCss,
  scssVariables as variables,
  userFullName,
  lang,
  scssVariables,
  events,
  useScreenDetail
} from 'src/helpers';

import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from './svg';
import { PopoverMenu, Avatar, MCButton, SelectField } from './basic';
import DrawerMenu from './DrawerMenu';
import LangSelect from './LangSelect';
import constants from 'src/constants';
import LANG_CONST from '../helpers/lang/const';
import { AccountStateSelect } from './user/AccountStateSelect';
const defaultCurrency = constants.general.defaultCurrency;

const MainLayout = React.memo(
  ({
    user,
    showBack,
    funcBack,
    children,
    isAdminPage = false,
    drawMenu = [],
    dropdownMenu = [],
    isSettings = false,
    currency,
    handleChangeCurrency
  }) => {
    const hasNotification = user?.unreadNotifications > 0;
    currency = isAdminPage ? currency : user?.currency || defaultCurrency;
    const wallet = (isAdminPage ? user?.appWallets?.[currency] : user?.wallets?.[currency]) || 0;
    const screen = useScreenDetail();

    const setting = (
      <PopoverMenu
        style={{ cursor: 'pointer' }}
        placement={'bottom-end'}
        triggerOffset={20}
        menu={(close, isOpen) => (
          <div className={'mc-auth-info-popup'}>
            <div className={'mc-list-item'} style={{ marginRight: 0, marginLeft: 0 }}>
              <Avatar image={user?.avatar} text={userFullName(user)} width={70} height={70} />
              <div className={'mc-list-item-center'}>
                <div>
                  {lang.t('Hi')}, {userFullName(user)}
                </div>
                <div>{user?.username}</div>
                {isOpen && <AccountStateSelect />}
              </div>
            </div>
            <ul>
              {dropdownMenu.map((item) => (
                <li key={item.key}>
                  <Link to={item.path} onClick={() => close()}>
                    {lang.t(typeof item.title === 'string' ? item.title : item.title(user))}
                  </Link>
                </li>
              ))}
              <li className={'mc-flex'}>
                <MCButton
                  label={'Logout'}
                  medium
                  radius
                  quaternary
                  light
                  flex
                  onClick={() => {
                    events.emit('logout');
                  }}
                />
              </li>
            </ul>
          </div>
        )}
      >
        {(isOpen) => (
          <div className={'mc-list-item'}>
            <Avatar
              width={50}
              height={50}
              image={(user?.avatar || '').replace('/full_', '/350_')}
              text={userFullName(user)}
            />
            {!screen?.isSmallScreen && (
              <div className={'mc-list-item-center'} style={{ whiteSpace: 'nowrap' }}>
                <div>
                  {lang.t('Hi')}, {userFullName(user)}
                </div>
                <div>{user?.username}</div>
              </div>
            )}
            <SVGIcon
              iconname={isOpen ? BASE_ICONS.UP : BASE_ICONS.DOWN}
              width={20}
              fill={scssVariables['colors-mc-text-light']}
            />
          </div>
        )}
      </PopoverMenu>
    );

    return (
      <div className={'mc-page-main'} data-testid='app-shell'>
        <DrawerMenu user={user} menu={drawMenu} isAdminPage={isAdminPage} isSettings={isSettings} />
        <div className={'mc-container'}>
          <div className={'mc-container-header mc-mobile'}>
            <div className={'mc-grow'}>
              <div
                className='mc-toggleBtn'
                onClick={() => document.body.classList.toggle('mc-asideOpen')}
                style={{ width: remCss(20) }}
              >
                <SVGIcon iconname='menu-bar-icon' />
              </div>
            </div>
            <div className={'mc-mr20'}>
              <LangSelect />
            </div>
            <Link
              className={'mc-notification'}
              to={(isAdminPage ? '/admin' : '') + '/settings/notification'}
            >
              {hasNotification && <div className={'mc-has-icon'} />}
              <SVGIcon iconname={BASE_ICONS.NOTIFICATION} />
            </Link>
            {setting}
          </div>
          <div className={'mc-container-header'} style={{ zIndex: 3 }}>
            {showBack && (
              <div onClick={funcBack} className={'mc-pointer'}>
                <SVGIcon iconname={'back-icon'} />
              </div>
            )}
            {/*{!isAdminPage && <SearchTextField onChange={onQuerySearchChange} value={querySearch} />}*/}

            <div className={'mc-grow'} />
            {isAdminPage && (
              <SelectField
                style={{ marginRight: remCss(20) }}
                template={'6'}
                isClearable={false}
                minWidth={remCss(150)}
                options={constants.general.currencyOptions}
                name={'currency'}
                value={currency}
                onChange={(n, v) => handleChangeCurrency(v)}
              />
            )}
            <LangSelect style={{ marginRight: remCss(20) }} />
            {isAdminPage && (
              <Link
                className={'mc-notification'}
                to={'/admin/settings'}
                style={{ marginRight: remCss(15) }}
              >
                <SVGIcon iconname={BASE_ICONS.SETTING} />
              </Link>
            )}

            <Link
              className={'mc-notification'}
              to={(isAdminPage ? '/admin' : '') + '/settings/notification'}
            >
              {hasNotification && <div className={'mc-has-icon'} />}
              <SVGIcon iconname={GENERAL_ICONS.NOTIFICATION} />
            </Link>
            {user?.isDoctor && (
              <Link className={'mc-wallet mc-flex'} to={'/settings/earning'}>
                <SVGIcon iconname={BASE_ICONS.WALLET} fill={variables['colors-mc-wallet']} />
                <span>
                  {number.format(wallet)} {currency}
                </span>
              </Link>
            )}
            {setting}
          </div>
          {isSettings && (
            <div className={'mc-settings-header'} style={{ zIndex: 2 }}>
              <span className={'mc-settings-header-label'}>{lang.t('Settings')}</span>
              <Link className={'mc-backtolifeapp'} to={'/'}>
                <SVGIcon
                  iconname={BASE_ICONS.BACK_ARROW}
                  fill={variables['colors-mc-primary']}
                  width={40}
                />
                <span>{lang.t(LANG_CONST.buttons.back_to_app)}</span>
              </Link>
            </div>
          )}
          {children}
        </div>
      </div>
    );
  }
);
MainLayout.displayName = 'MainLayout';

export default MainLayout;
